<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eML0uX/tc-custom/9781488091964.jpg?1738352962533" alt="This image is the cover for the book His Best Friend's Sister, First Family of Rodeo"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">His Best Friend's Sister, First Family of Rodeo
      </h1>
      <p class="bookDescription body article font2">
        <b>He’s always played by his family’s rules, until he plays house with an off-limits love in this Western romance “full of emotion and passion” (<i>Romance Reviews Today</i>).</b><br/><br/>Rodeo mogul Oliver Lawrence can’t say no to his best friend’s sister, pregnant widow Renee Preston. When the innocent beauty needs refuge from the tabloids, he offers his penthouse—and his bed. The passion between them is anything but innocent. And soon Oliver must choose: protect his family from her scandal or stand by the woman he can’t let go . . . <br/><br/><b>“Wow, what a way to start a series . . . Ms. Anderson has given her readers characters that you feel for right down to the bone marrow, they live, breathe, and the story compels.” —<i>Harlequin Junkie </i></b><br/><br/><b>“A sweet and sassy reuniting of old friends leads to a future neither was expecting! Kicking off a new rodeo series, we’re drawn quickly into Renee’s plight and follow her on a journey of redemption . . . I’m looking forward to more in the series!” —<i>Thoughts of a Blonde</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah M. Anderson
      </h2>
      
      <p class="authorDescription body article">Sarah M. Anderson won RT Reviewer&#39;s Choice 2012 Desire of the Year for <I>A Man of Privilege</I>. <I>The Nanny Plan</I> was a 2016 RITA&reg; winner for Contemporary Romance: Short.&#160;Find out more about Sarah&#39;s love of cowboys at www.sarahmanderson.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b563fc64